const mediaItems = [
  {
    title: '长安如故 · 精彩片花',
    category: '古装传奇',
    duration: '3:25',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20with%20ancient%20Chinese%20palace%20architecture%20in%20warm%20golden%20sunset%20light%2C%20traditional%20red%20lanterns%2C%20flowing%20silk%20curtains%2C%20soft%20atmospheric%20haze%2C%20historical%20drama%20aesthetic%2C%20rich%20warm%20tones%2C%20no%20people%2C%20elegant%20and%20cinematic&width=800&height=500&seq=wuma-media-01&orientation=landscape',
  },
  {
    title: '深渊之光 · 角色特辑',
    category: '悬疑刑侦',
    duration: '5:12',
    image: 'https://readdy.ai/api/search-image?query=A%20moody%20dark%20urban%20night%20scene%20with%20neon%20reflections%20on%20wet%20asphalt%2C%20rain%20drops%2C%20mysterious%20foggy%20alley%2C%20detective%20noir%20vibe%2C%20deep%20shadows%2C%20cool%20blue%20tone%20contrasting%20with%20warm%20street%20lamps%2C%20no%20people%2C%20cinematic%20and%20moody&width=800&height=500&seq=wuma-media-02&orientation=landscape',
  },
  {
    title: '星辰大海 · 幕后花絮',
    category: '都市情感',
    duration: '4:08',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20modern%20cityscape%20at%20dusk%20with%20soft%20twilight%20sky%2C%20city%20lights%20starting%20to%20glow%2C%20gentle%20bokeh%20effect%2C%20romantic%20urban%20atmosphere%2C%20warm%20golden%20hour%20tones%2C%20no%20people%2C%20elegant%20modern%20drama%20aesthetic&width=800&height=500&seq=wuma-media-03&orientation=landscape',
  },
  {
    title: '九州风云录 · 特效揭秘',
    category: '玄幻史诗',
    duration: '7:40',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20landscape%20with%20floating%20mountains%20and%20mystical%20golden%20light%20rays%20piercing%20through%20clouds%2C%20ancient%20temples%2C%20dramatic%20atmospheric%20fog%2C%20warm%20amber%20and%20gold%20tones%2C%20no%20people%2C%20grand%20cinematic%20scale%2C%20fantasy%20world-building&width=800&height=500&seq=wuma-media-04&orientation=landscape',
  },
  {
    title: '岁月如歌 · 经典片段',
    category: '年代温情',
    duration: '2:55',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20vintage%20Chinese%20courtyard%20scene%20with%20warm%20sunlight%20filtering%20through%20old%20trees%2C%20traditional%20wooden%20furniture%2C%20soft%20sepia-warm%20tones%2C%20peaceful%20and%20sentimental%20atmosphere%2C%20no%20people%2C%20period%20drama%20aesthetic%2C%20gentle%20golden%20light&width=800&height=500&seq=wuma-media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            精彩花絮
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            热门剧集精彩片花、幕后特辑与独家花絮，提前感受剧情魅力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, index) => (
            <div
              key={index}
              className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
            >
              <div className="aspect-video relative overflow-hidden">
                <img
                  src={item.image}
                  alt={`午马影院 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-background-950/30 group-hover:bg-background-950/20 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors shadow-lg">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-[10px] md:text-xs text-foreground-200 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}